import React from "react";
import { motion } from "framer-motion";
import styles from "../SoundDetails.module.css";
import { useTranslation } from "react-i18next";

const CeilingBose = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      className={styles.productDetails}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <motion.div
        className={styles.productImage}
        initial={{ x: -200 }}
        animate={{ x: 0 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/07-sound-system/Bose/01.png`}
          alt="Product"
        />
      </motion.div>

      <motion.div
        className={styles.productInfo}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.h1
          className={styles.productTitle}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          {t("ceilingBose.title")}
        </motion.h1>

        <motion.ul className={styles.productFeatures}>
          {t("ceilingBose.features", { returnObjects: true }).map(
            (feature, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4 + index * 0.2, duration: 0.6 }}
              >
                <span style={{ fontWeight: "bold" }}>{feature.bold}</span>{" "}
                {feature.text}
              </motion.li>
            )
          )}
        </motion.ul>
      </motion.div>
    </motion.div>
  );
};

export default CeilingBose;
